import Loadable from '../../../../components/loadable';
import prerenderedLoadable from '../../../../components/prerender';

const Page = Loadable(() =>
  import(/* webpackChunkName: "business-services-youcam-4-web" */ './index')
);

export default prerenderedLoadable(Page);
